/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Protocol_HintInputs */

const cs_templates_empty_protocol_hint = /** @type {(inputs: Templates_Empty_Protocol_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generovat protokol lze na úkolu prohlídky — ne odtud ze šablon.`)
};

const en_templates_empty_protocol_hint = /** @type {(inputs: Templates_Empty_Protocol_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate the protocol on a viewing task — not from the template studio.`)
};

/**
* | output |
* | --- |
* | "Generate the protocol on a viewing task — not from the template studio." |
*
* @param {Templates_Empty_Protocol_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_protocol_hint = /** @type {((inputs?: Templates_Empty_Protocol_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Protocol_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_protocol_hint(inputs)
	return cs_templates_empty_protocol_hint(inputs)
});